import { defineMessages } from 'react-intl';

export default defineMessages({
    generateQuoteDocument: {
        id: 'quoteandbind.cp.directives.Generate Quote Document',
        defaultMessage: 'Generate Quote Document',
    },
    generateQuoteDocumentConf: {
        id: 'quoteandbind.cp.directives.Are you sure you want to generate quote document',
        defaultMessage: 'Are you sure you want to generate quote document',
    },

});
